import { Controller } from "@hotwired/stimulus"
import { getCloudFrontKeyPairId } from "../vendor/cloudfront-utils.js"

// Connects to data-controller="quiz-image-loader"
// Loads question images from CloudFront CDN and sets dimensions for quiz pages
export default class extends Controller {
  static values = {
    itemUrl: String,
    policy: String,
    signature: String,
    keyPairId: String  // Optional - falls back to meta tag if not provided
  }

  // Get keyPairId from data attribute if provided, otherwise from meta tag
  get keyPairId() {
    return this.hasKeyPairIdValue ? this.keyPairIdValue : getCloudFrontKeyPairId()
  }

  connect() {
    this.loadImage()
  }

  loadImage() {
    if (!this.hasItemUrlValue) {
      console.warn('[quiz-image-loader] Missing itemUrl value')
      return
    }

    // Extract item ID from URL (e.g., "Questions/123.png" -> "123")
    const item = this.itemUrlValue.slice(3).replace(".png", "")
    const cover = document.getElementById(item)
    const target = document.getElementById(item + "-alt")

    if (!cover || !target) {
      console.warn(`[quiz-image-loader] Could not find elements for item: ${item}`)
      return
    }

    // Build CloudFront signed URL
    const imageUrl = `https://cdn.lsatengine.com/Questions/${this.itemUrlValue}?Policy=${this.policyValue}&Signature=${this.signatureValue}&Key-Pair-Id=${this.keyPairId}`
    target.src = imageUrl

    // Set dimensions when image loads
    target.onload = () => {
      const newWidth = target.naturalWidth / 2.0
      const imgWrap = document.querySelector('.img-wrap')

      if (imgWrap && window.jQuery) {
        window.jQuery(imgWrap).width(newWidth)
      } else if (imgWrap) {
        imgWrap.style.width = `${newWidth}px`
      }

      if (window.jQuery) {
        window.jQuery(target).width(newWidth)
        window.jQuery(cover).width(newWidth + 1)
        window.jQuery(cover).height((target.naturalHeight / 2.0) + 1)
      } else {
        target.style.width = `${newWidth}px`
        cover.style.width = `${newWidth + 1}px`
        cover.style.height = `${(target.naturalHeight / 2.0) + 1}px`
      }
    }
  }
}
